<template>
  <div class="orderDetail">
    <div class="main">
      <div class="m-box6">
        <div class="m-ems">
          <div class="tit">
            订单编号： {{orderDetailInfo.order_num}}
          </div>
          <div class="wp2">
            <ul class="ul-listz6">
              <li :class="orderDetailInfo.order_status == -1? 'on' : ''"
                  v-if="orderDetailInfo.order_status == -1&&orderDetailInfo.classify!=5">

                <span><i v-show="orderDetailInfo.order_status == -1">已退款</i></span>
                <div class="r-con" v-show="orderDetailInfo.order_status == -1"></div>
                <!--                          <span><i v-show="orderDetailInfo.order_status == 0">申请退款中</i></span>-->
                <!--                          <div class="r-con" v-show="orderDetailInfo.order_status == 0"></div>-->
              </li>
              <li :class="orderDetailInfo.order_status == 0 ? 'on' : ''"
                  v-if="orderDetailInfo.order_status == 0 &&orderDetailInfo.classify!=5">
                <span><i v-show="orderDetailInfo.order_status == 0">申请退款中</i></span>
                <div class="r-con" v-show="orderDetailInfo.order_status == 0">
                </div>
              </li>
              <li :class="orderDetailInfo.order_status >= 1 ? 'on' : ''">
                <span><i v-show="orderDetailInfo.order_status >= 1">待付款</i></span>
                <div class="r-con" v-show="orderDetailInfo.order_status >= 1">
                </div>
              </li>
              <li :class="orderDetailInfo.order_status >= 2 ? 'on' : ''">
                <span><i v-show="orderDetailInfo.order_status >= 2">已付款</i></span>
                <div class="r-con" v-show="orderDetailInfo.order_status >= 2">
                  付款成功！
                </div>
              </li>
              <li :class="orderDetailInfo.order_status >= 3 ? 'on' : ''">
                <span><i v-show="orderDetailInfo.order_status >= 3">已寄出采样工具</i> </span>
                <div class="r-con" v-show="orderDetailInfo.order_status >= 3">
                  <div class="con" v-if="type!=2">
                    顺丰快递 <br/>
                    运单编号： {{orderDetailInfo.courier_number}}
                  </div>
                </div>
              </li>
              <li :class="orderDetailInfo.order_status >= 4 ? 'on' : ''" v-if="orderDetailInfo.classify!=5">
                <span><i v-show="orderDetailInfo.order_status >= 4">已寄回样本</i></span>
                <div class="r-con" v-show="orderDetailInfo.order_status >= 4">
                  <div class="con">
                    顺丰快递 <br/>
                    运单编号： {{orderDetailInfo.express_number}}
                  </div>
                </div>
              </li>
              <li :class="orderDetailInfo.order_status >= 5 ? 'on' : ''" v-if="orderDetailInfo.classify!=5">
                <span><i v-show="orderDetailInfo.order_status >= 5">已收样</i></span>
                <div class="r-con" v-show="orderDetailInfo.order_status >= 5">
                  收样成功
                </div>
              </li>
              <!-- 分类 1 检测类,2 保存类,3 保管类, -->
              <li :class="orderDetailInfo.order_status >= 6 ? 'on' : ''" v-if="orderDetailInfo.classify!=5">
								<span>
									<i
                    v-show="(orderDetailInfo.classify == 2 || orderDetailInfo.classify == 3) && orderDetailInfo.order_status >= 6">制作完成</i>
									<i v-show="orderDetailInfo.classify == 1 && orderDetailInfo.order_status >= 6">报告生成</i>
								</span>
                <div class="r-con"
                     v-show="(orderDetailInfo.classify == 2 || orderDetailInfo.classify == 3) && orderDetailInfo.order_status >= 6">
                  <i>制作完成</i>
                </div>
                <!-- 检测类 -->
                <!-- <span ></span> style="min-height:40px;"-->
                <div class="r-con" v-show="orderDetailInfo.classify == 1 && orderDetailInfo.order_status >= 6">
                  已上传电子报告, 短信提醒号码{{orderDetailInfo.phone}}
                </div>
              </li>
              <li :class="orderDetailInfo.order_status >= 7 ? 'on' : ''" v-if="orderDetailInfo.classify!=5">
                <!-- 保存类 -->
                <span>
									<i v-show="orderDetailInfo.classify == 3 && orderDetailInfo.order_status >= 7">代保管中</i>
									<i v-show="orderDetailInfo.classify == 2 && orderDetailInfo.order_status >= 7">已寄出成品</i>
									<i v-show="orderDetailInfo.classify == 1 && orderDetailInfo.order_status >= 7">已寄出报告</i>
								</span>

                <div class="r-con">

                </div>
              </li>

            </ul>
          </div>
        </div>
        <div class="info">
          <ul class="ul-listz7">
            <li>
              <span>配送方式</span>
              <div class="r-con">
                <em>免运费</em>
              </div>
            </li>
            <!-- <li>
                        <span>买家留言:</span>
                        <div class="r-con">
                            无
                        </div>
                    </li> -->
            <!-- <li>
                        <span>合计:</span>
                        <div class="r-con">
                            <em>￥{{orderDetailInfo.money}}</em>
                        </div>
                    </li> -->
          </ul>
          <ul class="ul-listz7">
            <li>
              <span>付款方式</span>
              <div class="r-con">
                <em>{{orderDetailInfo.payment_style == 1 ? '微信支付' : '线下支付'}}</em>
              </div>
            </li>
            <li>
              <span>实付金额 :</span>
              <div class="r-con">
                <em class="em-r">￥{{ orderDetailInfo.money*1 + orderDetailInfo.services*1 }}</em>
              </div>
            </li>
          </ul>
          <ul class="ul-listz7">
            <li>
              <span>收货人地址</span>
              <div class="r-con">
                <em></em>
              </div>
            </li>
            <li>
              <span>姓名 : {{orderDetailInfo.consignee_name}}</span>
              <div class="r-con">
              </div>
            </li>
            <!-- <li>
                        <span>被采集人关系 :</span>
                        <div class="r-con">
                        </div>
                    </li> -->
            <li>
              <span>手机号 : {{orderDetailInfo.consignee_phone}}</span>
              <div class="r-con">
              </div>
            </li>
            <li v-if="type!=2">
              <span>收货地址 : {{orderDetailInfo.consignee_address}}</span>
              <div class="r-con">
              </div>
            </li>
            <!-- <li>
                        <span>身份证号 :</span>
                        <div class="r-con">
                        </div>
                    </li> -->
          </ul>
          <ul class="ul-listz7" v-if="orderDetailInfo.classify != 5">
            <li>
              <span>被采集人信息</span>
              <div class="r-con">
                <em></em>
              </div>
            </li>
            <li>
              <span>姓名 :{{orderDetailInfo.gather_name}}</span>
              <div class="r-con">
              </div>
            </li>
            <li>
              <span>性别 :{{orderDetailInfo.gather_sex}}</span>
              <div class="r-con">
              </div>
            </li>
            <li>
              <span>出生日期 :{{orderDetailInfo.gather_time}}</span>
              <div class="r-con">
              </div>
            </li>
            <!--                    <li>-->
            <!--                        <span>身份证号 :{{orderDetailInfo.card}}</span>-->
            <!--                        <div class="r-con">-->
            <!--                        </div>-->
            <!--                    </li>-->
          </ul>


          <ul class="ul-listz7" v-if="orderDetailInfo.classify != 5">
            <li>
              <span>成品/报告信息</span>
              <div class="r-con">
                <em></em>
              </div>
            </li>
            <li>
              <span>姓名 :{{orderDetailInfo.product_name}}</span>
              <div class="r-con">
              </div>
            </li>
            <li>
              <span>身份证号 :{{orderDetailInfo.card}}</span>
              <div class="r-con">
              </div>
            </li>
            <li>
              <span>报告查询手机号 :{{orderDetailInfo.phone}}</span>
              <div class="r-con">
              </div>
            </li>
            <li>
              <span>收件地址 :{{orderDetailInfo.address}}</span>
              <div class="r-con">
              </div>
            </li>
          </ul>
          <div v-if="type!=3">
            <div class="sqtuikuan" @click="sqtk(orderDetailInfo.order_id)"
                 v-if="orderDetailInfo.order_status<6&&orderDetailInfo.order_status>1">申请退款
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
   import Vue from 'vue'
   import {
      Dialog
   } from 'vant'

   Vue.use(Dialog)
   export default {
      name: 'orderDetail',
      data() {
         return {
            order_id: this.$route.params.order_id,
            orderDetailInfo: {},
            type: ''
         }
      },
      created() {
         let that = this;
         that.type = localStorage.getItem('type')
console.log('order_id22:',that.order_id)
         that.findNcByOrderId()
      },
      methods: {
         //申请退款
         sqtk(orderid) {
            let that = this
            Dialog.confirm({
               message: '确定申请退款吗'
            }).then(() => {
               that.$http.api.sqtk({
                  order_id: orderid,
                  order_status: 0
               }).then(result => {
                  that.$createToast({
                     txt: '申请成功',
                     type: 'txt'
                  }).show()
                  setTimeout(function () {
                     that.$router.go(-1)
                  }, 2000)
               })
            })
         },
         loadPage() {
            let _this = this
            _this.$http.api.orderAppoint({
               order_id: _this.order_id
            }).then(result => {

               _this.orderDetailInfo = {
                  ...result
               }
            })
         },
         findNcByOrderId() {

            let that = this;
            that.$http.api.findNcByOrderId({
               order_id: that.order_id
            }).then(result => {
               that.loadPage();
            })
         },

      },

   }
</script>
<style lang="less" scoped>
  .sqtuikuan {
    width: 100%;
    height: 40px;
    line-height: 40px;
    display: table;
    background-color: #60B0E3;
    text-align: center;
    color: #ffffff;
    margin: 10px 0px 0px;
    font-size: 0.38rem;
  }
</style>
